/** Shared list pagination helpers (Accounts / Locations style). */

export const PAGE_SIZE_OPTIONS = [20, 50, 100, 500, 1000, 'all'];

/** Build page numbers with ellipsis, e.g. [1, '…', 4, 5, 6, '…', 20] */
export const buildPageItems = (current, total) => {
  if (total <= 7) {
    return Array.from({ length: Math.max(total, 1) }, (_, i) => i + 1);
  }
  const pages = new Set([1, total, current, current - 1, current + 1, current - 2, current + 2]);
  const sorted = [...pages].filter((p) => p >= 1 && p <= total).sort((a, b) => a - b);
  const items = [];
  let prev = 0;
  sorted.forEach((p) => {
    if (prev && p - prev > 1) items.push('…');
    items.push(p);
    prev = p;
  });
  return items;
};

export const resolveTakeSkip = (page, pageSize) => {
  if (pageSize === 'all') {
    return { skip: 0, take: 0 }; // 0 = all when API supports it; else caller fetches total first
  }
  const size = Number(pageSize) || 20;
  return { skip: (page - 1) * size, take: size };
};
